import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { DataTableCard } from './';
import { useBinderCardColors } from '../hooks/useBinderCardColors';

interface PolicyChangeFormsCardProps {
  sectionData: BinderSectionData;
}

const PolicyChangeFormsCard: React.FC<PolicyChangeFormsCardProps> = ({
  sectionData,
}) => {
  const { data } = sectionData;
  const { forms = [] } = data || {};
  const colors = useBinderCardColors();

  const headers = ['Auto Name & No.', 'Form Type', 'Deductible', 'Premium'];

  const rows = forms.map((form: any) => [
    form.autoName,
    form.formType,
    form.deductible,
    form.premium,
  ]);

  // Handle case when no forms
  if (forms.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No policy change forms found
        </Text>
      </Box>
    );
  }

  return (
    <Box>
      <DataTableCard
        description="Policy modification forms and coverage changes"
        headers={headers}
        rows={rows}
      />
    </Box>
  );
};

export default PolicyChangeFormsCard;
